<h2>Update Vessel Subgroups for {{ vesselType }} - {{ vesselSubgroupForm.get('subType')?.value }}</h2>

<form [formGroup]="vesselSubgroupForm" (ngSubmit)="updateVesselSubgroups()">
<div class="form-group mb-3">
  <label for="subType">Sub Type:</label>
  <input type="text" id="subType" formControlName="subType" class="form-control">
  <div *ngIf="vesselSubgroupForm.get('subType')?.invalid && vesselSubgroupForm.get('subType')?.touched" class="text-danger">
    Sub Type is required.
  </div>
</div>
  <div class="form-group mb-3">
    <label for="lifetime">Lifetime:</label>
    <input type="number" id="lifetime" formControlName="lifetime" class="form-control" min="0">
    <div *ngIf="vesselSubgroupForm.get('lifetime')?.invalid && vesselSubgroupForm.get('lifetime')?.touched" class="text-danger">
      Lifetime is required and must be ≥ 0.
    </div>
    <div *ngIf="errors['lifetime']" class="text-danger">
      <ul>
        <li *ngFor="let error of errors['lifetime']">{{ error }}</li>
      </ul>
    </div>
  </div>
  <div class="form-group mb-3">
    <label for="conversionFactor">Conversion Factor:</label>
    <input type="number" id="conversionFactor" formControlName="conversionFactor" class="form-control" min="0">
    <div *ngIf="vesselSubgroupForm.get('conversionFactor')?.invalid && vesselSubgroupForm.get('conversionFactor')?.touched" class="text-danger">
      Conversion factor is required and must be ≥ 0
    </div>
    <div *ngIf="errors['conversionFactor']" class="text-danger">
      <ul>
        <li *ngFor="let error of errors['conversionFactor']">{{ error }}</li>
      </ul>
    </div>
  </div>

  <div *ngIf="subgroups.length > 0" formArrayName="subgroups" class="table-responsive">
    <table class="table table-bordered table-striped">
      <thead >
        <tr>
          <th>SFI Code</th>
          <th>Description</th>
          <th>Emission Factor</th>
          <th>Weight Distribution</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let subgroup of subgroups.controls; let i = index" [formGroupName]="i">
          <td>
            <input type="text" formControlName="sfiCode" class="form-control" disabled *ngIf="subgroup.get('description')?.value !== 'Assembly'">
            <div *ngIf="errors['subgroups.' + i + '.sfiCode']" class="text-danger">
              <ul><li *ngFor="let error of errors['subgroups.' + i + '.sfiCode']">{{ error }}</li></ul>
            </div>
          </td>
          <td>
            <input type="text" formControlName="description" class="form-control" disabled>
            <div *ngIf="errors['subgroups.' + i + '.description']" class="text-danger">
              <ul><li *ngFor="let error of errors['subgroups.' + i + '.description']">{{ error }}</li></ul>
            </div>
          </td>
          <td>
            <input type="number" formControlName="coefficient" class="form-control" >
            <div *ngIf="subgroup.get('coefficient')?.invalid && subgroup.get('coefficient')?.touched" class="text-danger">
              Required and must be ≥ 0
            </div>
            <div *ngIf="errors['subgroups.' + i + '.coefficient']" class="text-danger">
              <ul><li *ngFor="let error of errors['subgroups.' + i + '.coefficient']">{{ error }}</li></ul>
            </div>
          </td>
          <td>
<input
  type="number"
  formControlName="weightDistribution"
  class="form-control"
  min="0"
  *ngIf="subgroup.get('description')?.value !== 'Assembly'"
  [disabled]="subgroup.get('description')?.value?.trim().toLowerCase() === 'assembly'"
>
            <div *ngIf="subgroup.get('weightDistribution')?.invalid && subgroup.get('weightDistribution')?.touched" class="text-danger">
              Required and must be ≥ 0
            </div>
            <div *ngIf="errors['subgroups.' + i + '.weightDistribution']" class="text-danger">
              <ul><li *ngFor="let error of errors['subgroups.' + i + '.weightDistribution']">{{ error }}</li></ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div
  class="mt-2 mb-3"
  [ngClass]="isWeightDistributionValid ? 'text-success' : 'text-danger'"
>
  Current total: {{ weightDistributionTotal | number:'1.0-2' }}%
</div>


  <div *ngIf="subgroups.errors?.weightDistributionNotEqual" class="text-danger mb-3">
    Total weight distribution must be exactly 100%.
  </div>

  <div *ngIf="errors.general" class="alert alert-danger mt-3">
    <ul>
      <li *ngFor="let err of errors.general">{{ err }}</li>
    </ul>
  </div>

<button type="submit" class="btn btn-primary mt-3" [disabled]="vesselSubgroupForm.invalid || isSubmitting">
  {{ isSubmitting ? 'Submitting...' : 'Update Vessel Subgroups' }}
</button>

</form>
